<template>
  <div class="systemFixing">
    系统升级中，暂无数据
  </div>
</template>

<script>
  export default {
    name: "SystemUpdating"
  };
</script>

<style scoped>
  .systemFixing {
    width: 100%;
    height: 100%;
    line-height: 253px;
    text-align: center;
  }

</style>